import useSessionStorageState from './src/useSessionStorageState';
export default useSessionStorageState;